var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.58332H3.925L8.4625 2.40665C8.67467 2.11734 8.77675 1.74436 8.74628 1.36976C8.7158 0.995154 8.55527 0.649613 8.3 0.40915C8.04473 0.168687 7.71563 0.0529996 7.3851 0.0875376C7.05456 0.122076 6.74967 0.30401 6.5375 0.593317L0.2875 9.09332C0.245451 9.16093 0.207849 9.23195 0.175 9.30582C0.175 9.37665 0.175 9.41915 0.0875002 9.48998C0.0308421 9.65242 0.0011764 9.82532 0 9.99998C0.0011764 10.1746 0.0308421 10.3475 0.0875002 10.51C0.0875002 10.5808 0.0874998 10.6233 0.175 10.6941C0.207849 10.768 0.245451 10.839 0.2875 10.9067L6.5375 19.4066C6.65503 19.5666 6.8022 19.6952 6.96856 19.7833C7.13491 19.8715 7.31636 19.917 7.5 19.9166C7.79207 19.9173 8.07511 19.802 8.3 19.5908C8.42657 19.4719 8.5312 19.3258 8.60789 19.161C8.68458 18.9962 8.73183 18.8158 8.74692 18.6303C8.76202 18.4447 8.74466 18.2576 8.69586 18.0797C8.64705 17.9017 8.56775 17.7365 8.4625 17.5933L3.925 11.4166H18.75C19.0815 11.4166 19.3995 11.2674 19.6339 11.0017C19.8683 10.736 20 10.3757 20 9.99998C20 9.62426 19.8683 9.26393 19.6339 8.99825C19.3995 8.73257 19.0815 8.58332 18.75 8.58332Z",
    fill: "#FFFFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIcon);
export default __webpack_public_path__ + "static/media/arrow-back-icon.4f1d5ccc7b65b94a18ac218521199e4a.svg";
export { ForwardRef as ReactComponent };